// extracted by mini-css-extract-plugin
export default {"icon":"profileMediaCounter_icon__9yWOP","counter":"profileMediaCounter_counter__GbX4-"};